import { useAppDispatch } from "../../../Redux/hooks";
import { setQuestionModalDetails } from "../../../Redux/reducers/questionSlice";
import { PreviewcomponentMap } from "./PreviewMap";
import { Settings } from "@mui/icons-material";
import MDEditor from "@uiw/react-md-editor/nohighlight";
import rehypeSanitize from "rehype-sanitize";
import React, { useState } from "react";
import ImagePreview from "../../Common/UI/ImagePreview";
import { Stack, Typography } from "@mui/material";
import { previewIndexStyle } from "../question.style";

type BlockProp = {
  question: any;
  index: number;
};

const QuestionBlockMinimal: React.FC<BlockProp> = ({ question, index }) => {
  const dispatch = useAppDispatch();
  const [showImagePreview, setImagePreview] = useState(false);
  const toggleImagePreview = () => {
    setImagePreview((prev) => !prev);
  };

  const handleEditQuestion = () => {
    dispatch(
      setQuestionModalDetails({
        question,
        show: true,
        modalIsEdit: true,
      })
    );
  };

  const Component = PreviewcomponentMap[question.type];

  return (
    <div className="preview-block">
      <div className="details-block">
        <div className="details">
          {["statement", "summary"].includes(question.type) &&
          !question?.properties?.showIndex ? (
            <></>
          ) : (
            <Stack sx={previewIndexStyle}>
              {question?.properties?.displayNumber
                ? question?.properties?.displayNumber
                : index + 1}
            </Stack>
          )}

          <div className="label-container">
            <div
              className={
                question?.properties?.required
                  ? "label-wrapper required"
                  : "label-wrapper"
              }
            >
              <MDEditor.Markdown
                wrapperElement={{
                  "data-color-mode": "light",
                }}
                source={question.labelMarkdown}
                rehypePlugins={[rehypeSanitize]}
                style={{ fontWeight: "400", fontSize: "14px" }}
              />
            </div>
          </div>
        </div>

        <div className="settings-block">
          <Settings
            sx={{ color: "#71717A" }}
            onClick={handleEditQuestion}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>

      {(Component || question?.signedImageUrl) && (
        <div
          className={
            ["grid", "repeated_data"].includes(question.type)
              ? "component-block full-w"
              : "component-block"
          }
        >
          {question?.signedImageUrl && (
            <Stack>
              <div className="image-container" onClick={toggleImagePreview}>
                <img
                  src={question.signedImageUrl}
                  alt="preview"
                  className="preview-image"
                />
              </div>
              <Typography variant="body1" color="text.secondary">
                Click on image to view the enlarged image
              </Typography>
            </Stack>
          )}
          {Component && <Component currentQuestion={question} />}
        </div>
      )}

      {showImagePreview && (
        <ImagePreview
          closeHandler={toggleImagePreview}
          image={question.signedImageUrl || ""}
        />
      )}
    </div>
  );
};

export default React.memo(QuestionBlockMinimal);
